import { Avatar, Box, Stack, Tab, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PersonalInformation from "../../components/IndividualStudent/PersonalInformation";
import Navbar from "../../components/shared/Navbar";
import { flexCenter } from "../../utilities/commonStyles/commonStyles";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Attendance from "./Attendance";
import { getClass } from "../../utilities/const/functions";

export default function DetailInfoArchived() {
  const [userData, setUserData] = useState({});
  const [value, setValue] = useState(1);
  const [classCodeData, setClassCodeData] = useState([]);
  const location = useLocation();

  const getClassData = async (classCode) => {
    // console.log({ classCode });
    let classData = classCode?.map(async (e) => {
      const res = await getClass(e);
      return { ...res.data, id: e };
    });

    let processedClassData = await Promise.all(classData);
    // console.log({ processedClassData });
    setClassCodeData(processedClassData);
  };
  // console.log(classCode);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setUserData(location?.state?.userData);
    getClassData(location?.state?.userData?.classCode);
  }, [location?.state?.userData]);
  return (
    <Box>
      <Navbar pageTags={["Home", "Student Information", "Archived", "Info"]} />
      <Box sx={{ width: "100%", py: "50px", backgroundColor: "#F4F7FB" }}>
        <Box
          sx={{
            px: 5,
            minWidth: "850px",
            mx: "auto",
            display: "flex",
            gap: "50px",
          }}
        >
          <Box
            sx={{
              background: "#FFF",
              padding: "30px 15px",
              borderRadius: "14px",
              minWidth: "25%",
              minHeight: "80vh",
            }}
          >
            <Box sx={{ ...flexCenter }}>
              <Avatar
                src={userData?.image ?? ""}
                sx={{
                  width: "165px",
                  height: "165px",
                  borderRadius: "50%",
                }}
              />
            </Box>
            <Stack spacing={2} sx={{ mt: "30px" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "30px",
                  color: "#5C5C5C",
                }}
              >
                <span style={{ fontWeight: 500, color: "#242424" }}>Name:</span>{" "}
                {userData?.name ?? ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "30px",
                  color: "#5C5C5C",
                }}
              >
                <span style={{ fontWeight: 500, color: "#242424" }}>ID:</span>{" "}
                {userData?.id ?? ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "30px",
                  color: "#5C5C5C",
                }}
              >
                <span style={{ fontWeight: 500, color: "#242424" }}>
                  Telephone Number:
                </span>{" "}
                {userData?.phone ?? ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "30px",
                  color: "#5C5C5C",
                }}
              >
                <span style={{ fontWeight: 500, color: "#242424" }}>
                  Email:
                </span>{" "}
                {userData?.email ?? ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "30px",
                  color: "#5C5C5C",
                }}
              >
                <span style={{ fontWeight: 500, color: "#242424" }}>
                  Message:
                </span>{" "}
                {userData?.message ?? ""}
              </Typography>
            </Stack>
          </Box>

          <Box
            sx={{
              backgroundColor: "#F4F7FB",
              minHeight: "85vh",
              minWidth: "67%",
            }}
          >
            <Box sx={{ width: "100%", backgroundColor: "transparent" }}>
              <TabContext value={value}>
                <Box>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Personal Info" value={1} />
                    {/* <Tab label="Attendance" value={2} /> */}
                  </TabList>
                </Box>
                <TabPanel value={1}>
                  <PersonalInformation data={userData} archive={true} />
                </TabPanel>
                {/* <TabPanel value={2}>
                  <Attendance data={userData} classCodeData={classCodeData} />
                </TabPanel> */}
              </TabContext>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
